import { render, staticRenderFns } from "./newExamByScantronDialog.vue?vue&type=template&id=2f465fc4"
import script from "./newExamByScantronDialog.vue?vue&type=script&lang=js"
export * from "./newExamByScantronDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports